// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetIndexAdvisorConfigForDatabaseQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type GetIndexAdvisorConfigForDatabaseQuery = {
  __typename?: "GraphqlQuery";
  getIndexAdvisorConfigForDatabase: Array<{
    __typename?: "IndexAdvisorConfigForTable";
    id: string;
    schemaName: string;
    tableName: string;
    settingsName: string;
    scansPerMin?: number | null;
    lastRunAt?: number | null;
  }>;
};

export const GetIndexAdvisorConfigForDatabaseDocument = gql`
  query GetIndexAdvisorConfigForDatabase($databaseId: ID!) {
    getIndexAdvisorConfigForDatabase(databaseId: $databaseId) {
      id
      schemaName
      tableName
      settingsName
      scansPerMin
      lastRunAt
    }
  }
`;

/**
 * __useGetIndexAdvisorConfigForDatabaseQuery__
 *
 * To run a query within a React component, call `useGetIndexAdvisorConfigForDatabaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexAdvisorConfigForDatabaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexAdvisorConfigForDatabaseQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useGetIndexAdvisorConfigForDatabaseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  > &
    (
      | {
          variables: GetIndexAdvisorConfigForDatabaseQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  >(GetIndexAdvisorConfigForDatabaseDocument, options);
}
export function useGetIndexAdvisorConfigForDatabaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  >(GetIndexAdvisorConfigForDatabaseDocument, options);
}
// @ts-ignore
export function useGetIndexAdvisorConfigForDatabaseSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorConfigForDatabaseQuery,
  GetIndexAdvisorConfigForDatabaseQueryVariables
>;
export function useGetIndexAdvisorConfigForDatabaseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorConfigForDatabaseQuery,
        GetIndexAdvisorConfigForDatabaseQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorConfigForDatabaseQuery | undefined,
  GetIndexAdvisorConfigForDatabaseQueryVariables
>;
export function useGetIndexAdvisorConfigForDatabaseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorConfigForDatabaseQuery,
        GetIndexAdvisorConfigForDatabaseQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIndexAdvisorConfigForDatabaseQuery,
    GetIndexAdvisorConfigForDatabaseQueryVariables
  >(GetIndexAdvisorConfigForDatabaseDocument, options);
}
export type GetIndexAdvisorConfigForDatabaseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorConfigForDatabaseQuery
>;
export type GetIndexAdvisorConfigForDatabaseLazyQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorConfigForDatabaseLazyQuery
>;
export type GetIndexAdvisorConfigForDatabaseSuspenseQueryHookResult =
  ReturnType<typeof useGetIndexAdvisorConfigForDatabaseSuspenseQuery>;
export type GetIndexAdvisorConfigForDatabaseQueryResult = Apollo.QueryResult<
  GetIndexAdvisorConfigForDatabaseQuery,
  GetIndexAdvisorConfigForDatabaseQueryVariables
>;
